import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpPhotographersSsoConfigured} from '@features/user/http/user.http.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {QUERY_KEYS} from '@/queryClient'

export const usePhotographersSsoConfigured = (options?: Omit<UseMutationOptions<unknown>, 'queryKey' | 'queryFn'>) => {
    const queryClient = useQueryClient()
    return useMutation({
        ...options,
        mutationFn: httpPhotographersSsoConfigured,
        onError: errorHandler,
        onSuccess: (data, variables, context) => {
            options?.onSuccess?.(data, variables, context)
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ME]})
        }
    })
}
